import { FilterMoreDisplay } from 'app/modules/filters/components/FilterMoreDisplay';
import {
  FILTER_OPERATOR,
  FILTER_TYPE_OPERATOR_LABELS,
} from 'app/modules/filters/constants';
import { AIRecommendation } from 'app/modules/aiAgentResults/models';

interface Props {
  value: string[];
}

const AI_RECOMMENDATION_LABELS: Record<
  NonNullable<AIRecommendation> | '',
  string
> = {
  FALSE_POSITIVE: 'Close as false positive',
  UNDETERMINED: 'Human review requested',
  '': 'Awaiting recommendation',
};

export const AiRecommendationFilterDisplay = ({ value }: Props) => {
  const formattedValues = value.map((recommendation) => {
    return AI_RECOMMENDATION_LABELS[recommendation] || recommendation;
  });

  return (
    <>
      <b>AI recommendation</b>{' '}
      {FILTER_TYPE_OPERATOR_LABELS[FILTER_OPERATOR.IS_ONE_OF]}&nbsp;
      <FilterMoreDisplay values={formattedValues} />
    </>
  );
};
